import DefaultValidation from "@/services/validations/DefaultValidation";
import { isNull } from "@/functions/Util";

export default class RegraDescontoValidation extends DefaultValidation{
    validate(model, refs, msg) {
        let validated = true;

        Object.entries(model).forEach(([key, value]) => {
            if(value!=null && typeof value == "string") model[key] = value.trim();
        });

        if (isNull(model.idVenPoliticaDescontoErp)) {
            refs.codigoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.tabelaPreco) || isNull(model.tabelaPreco.idtabpreco)) {
            refs.tabpreco.focusedOut = true;
            validated = false;
        }

        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.dataInicial)) {
            refs.dataInicial.focusedOut = true;
            validated = false;
        }

        if (isNull(model.dataFinal)) {
            refs.dataFinal.focusedOut = true;
            validated = false;
        }

        if (isNull(model.tipoOperacaoUsada)) {
            refs.tipoOperacaoUsada.focusedOut = true;
            validated = false;
        }
        
        if (isNull(model.formaAplicarRegra)) {
            refs.formaAplicarRegra.focusedOut = true;
            validated = false;
        }
        
        if (isNull(model.dataInicial > model.dataFinal)) {
            refs.dataInicial.focusedOut = true;
            refs.dataFinal.focusedOut = true;
            msg = 'data-menor-que-data-inicial'
            validated = false;
        }

        return validated;
    }
}